import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { HR } from 'foundations-components/transitional/components/HR';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BREACHED_PROPERTY_VALUE, IN_SLA_PROPERTY_VALUE, RESOLVED_IN_SLA_PROPERTY_VALUE, RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE, SLA_WARNING_PROPERTY_VALUE } from 'conversations-internal-schema/sla/constants/enums';
import { SLADetailsRow } from '../_internal/components/SLADetailsRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SLATooltipHeader = ({
  activeSLAStatus
}) => {
  switch (activeSLAStatus) {
    case IN_SLA_PROPERTY_VALUE:
    case RESOLVED_IN_SLA_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.inSLA"
      });
    case BREACHED_PROPERTY_VALUE:
    case RESOLVED_OUTSIDE_SLA_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.breached"
      });
    case SLA_WARNING_PROPERTY_VALUE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.statusHeaders.warning"
      });
    default:
      throw new Error(`SLA status ${activeSLAStatus} is not in SLAStatusEnum`);
  }
};
SLATooltipHeader.displayName = 'SLATooltipHeader';
export const SLADetailsTooltip = ({
  children,
  slas,
  activeSLA
}) => {
  const SLATooltipContent = () => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.slaStatus"
      }), /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(SLATooltipHeader, {
          activeSLAStatus: activeSLA.status
        })
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "xs"
    }), Object.values(slas).map(sla => /*#__PURE__*/_jsx(SLADetailsRow, {
      slaDetails: sla
    }, sla.category))]
  });
  SLATooltipContent.displayName = 'SLATooltipContent';
  return /*#__PURE__*/_jsx(Tooltip, {
    use: "longform",
    placement: "bottom",
    Content: SLATooltipContent,
    maxInlineSize: "600px",
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
SLADetailsTooltip.displayName = 'SLADetailsTooltip';